import { MapLayer } from 'components/Map/constants';
import { useEffect, useRef } from 'react';
import useMapLayersState from 'state/useMapLayersState';

export const useEnableLayersWithAutoReset = (
  layersToEnable: MapLayer[],
): void => {
  const { mapLayers, setMapLayerVisibility } = useMapLayersState();

  const initialLayersOfInterestStateRef = useRef(
    layersToEnable.reduce(
      (acc, layer) => ({
        ...acc,
        [layer]: mapLayers.includes(layer),
      }),
      {} as Record<MapLayer, boolean>,
    ),
  );

  useEffect(() => {
    const initialLayersOfInterestState =
      initialLayersOfInterestStateRef.current;

    // Enable layers of interest based on the initial enabled state.
    Object.entries(initialLayersOfInterestState).forEach(([layer, enabled]) => {
      if (!enabled) setMapLayerVisibility(layer, true);
    });

    return () => {
      // Reset the layers of interest enabled state to their initial values.
      Object.entries(initialLayersOfInterestState).forEach(
        ([layer, enabled]) => {
          setMapLayerVisibility(layer, enabled);
        },
      );
    };
  }, [setMapLayerVisibility]);
};
